import React from "react";

const UpStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.20748 7.73214C3.92148 8.03177 3.93252 8.50651 4.23214 8.79252C4.53177 9.07852 5.00651 9.06748 5.29252 8.76786L4.20748 7.73214ZM10 2.75L10.5425 2.23214C10.401 2.08388 10.205 2 10 2C9.79504 2 9.599 2.08388 9.45748 2.23214L10 2.75ZM14.7075 8.76786C14.9935 9.06748 15.4682 9.07852 15.7679 8.79252C16.0675 8.50651 16.0785 8.03177 15.7925 7.73214L14.7075 8.76786ZM5.29252 8.76786L10.5425 3.26786L9.45748 2.23214L4.20748 7.73214L5.29252 8.76786ZM9.45748 3.26786L14.7075 8.76786L15.7925 7.73214L10.5425 2.23214L9.45748 3.26786Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.75 3C10.75 2.58579 10.4142 2.25 10 2.25C9.58579 2.25 9.25 2.58579 9.25 3L10.75 3ZM9.25 17.25C9.25 17.6642 9.58579 18 10 18C10.4142 18 10.75 17.6642 10.75 17.25L9.25 17.25ZM9.25 3L9.25 17.25L10.75 17.25L10.75 3L9.25 3Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(UpStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;